const isValidDate = (value) => value instanceof Date && !Number.isNaN(value.getTime());

export const parseDate = (timeStr) => {
	if (!timeStr) return new Date("");

	if (timeStr instanceof Date) {
		return timeStr;
	}

	if (typeof timeStr === "number") {
		return new Date(timeStr);
	}

	const normalized = String(timeStr).trim();

	const directDate = new Date(normalized);
	if (isValidDate(directDate)) {
		return directDate;
	}

	const [date, time = "00:00:00"] = normalized.split(" ");
	if (!date?.includes("-")) {
		return new Date("");
	}

	const [day, month, year] = date.split("-");
	if (!day || !month || !year) {
		return new Date("");
	}

	return new Date(`${year}-${month}-${day}T${time}`);
};

export const formatDateLabel = (timeStr) => {
	const msgDate = parseDate(timeStr);
	if (!isValidDate(msgDate)) return "";
	const now = new Date();

	const yesterday = new Date();
	yesterday.setDate(now.getDate() - 1);

	if (msgDate.toDateString() === now.toDateString()) return "Today";
	if (msgDate.toDateString() === yesterday.toDateString()) return "Yesterday";

	return msgDate.toLocaleDateString([], {
		day: "numeric",
		month: "long",
		year: "numeric",
	});
};

export const formatTimeSmart = (timeStr) => {
	if (!timeStr) return "";

	const msgDate = parseDate(timeStr);
	if (!isValidDate(msgDate)) return "";
	const now = new Date();

	const isToday = msgDate.toDateString() === now.toDateString();

	const yesterday = new Date();
	yesterday.setDate(now.getDate() - 1);

	const isYesterday = msgDate.toDateString() === yesterday.toDateString();

	const diffDays = Math.floor((now - msgDate) / (1000 * 60 * 60 * 24));

	if (isToday) {
		return msgDate.toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit",
		});
	}

	if (isYesterday) return "Yesterday";

	if (diffDays < 7) {
		return msgDate.toLocaleDateString([], {
			weekday: "long",
		});
	}

	return msgDate.toLocaleDateString([], {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
};

export const formatMessageTime = (timeStr) => {
	if (!timeStr) return "";

	const msgDate = parseDate(timeStr);
	if (!isValidDate(msgDate)) return "";

	return msgDate.toLocaleTimeString([], {
		hour: "2-digit",
		minute: "2-digit",
	});
};
